import { action as apiAction } from 'api/Api'
import {
  setReason
} from '../redux/cardBlockers'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardBlockerId: number
  reason?: string
}

const requestChangeCardBlockerReason = ({
  cardBlockerId,
  reason,
}: Payload) => async dispatch => {
  const optimisticAction = optimisticDispatch(dispatch, setReason({
    cardBlockerId,
    reason,
  }))

  try {
    await apiAction('ChangeCardBlockerReason', {
      id: cardBlockerId,
      reason,
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestChangeCardBlockerReason
